// extracted by mini-css-extract-plugin
export default {"root":"M0odQWoWls1pXCj5BWQS","details":"VOnLS01ay_SO6nsooIcY","name":"GSzlTVS_8OTEnXIC5357","icon":"ZRkSi5H1ApRJYQ3oGHJU","title":"IjzuV_Ci2fBJLCgfndDz"};